import ReactDOM from 'react-dom';
import 'assets/tailwind.output.css';
import ApolloProvider from 'ApolloProvider';

ReactDOM.render(ApolloProvider, document.getElementById('root'));
